module.exports = __webpack_public_path__ + "img/product-three-2.99f3f7ad.png";